import { type z } from 'zod'

import { schemas } from '~interface/zod-schema'

import { type CrawlStatus } from '../types/ai'

// Values
export const OrganizationType = schemas.OrganizationTypeEnum

// Types
export type OrganizationTypeEnum = z.infer<typeof schemas.OrganizationTypeEnum>
export type Organization = z.infer<typeof schemas.Organization>
export type OrganizationTemplate = z.infer<typeof schemas.OrganizationTemplate>
export type QuillDashboard = z.infer<typeof schemas.QuillDashboard>

export type ListOrganizationsViewRequestData = z.infer<
  typeof schemas.ListOrganizationsViewRequestData
>
export type ListOrganizationsViewResponseData = z.infer<
  typeof schemas.ListOrganizationsViewResponseData
>

export type EnrichedOrganization = z.infer<typeof schemas.EnrichedOrganization>
export type OrganizationAndCustomerData = z.infer<typeof schemas.OrganizationAndCustomerData>
export type CustomerPurchasedStatuses = z.infer<
  typeof schemas.GetCustomerPurchasedStatusesViewResponseData
>
export type CustomerTypeEnum = z.infer<typeof schemas.CustomerTypeEnum>

export interface ICrawlTasksSort {
  by_field: 'crawled' | 'url'
  direction: 'asc' | 'desc'
}

export interface ICrawlTask {
  id: string
  organization: string
  url: string
  crawl: boolean
  active: boolean
  sitemap: string | null
  status: CrawlStatus
  cadence: string | null
  crawled: string | null
  next_crawl: string | null
  last_run_status?: CrawlStatus
  last_run_time?: string | null
  site_type?: string | null
  exclude_paths?: string | null
  include_only_paths?: string | null
  include_tags?: string | null
  exclude_tags?: string | null
  allow_backward_links?: boolean
  max_depth?: number | null
  metadata?: unknown
  web_search_active?: boolean | null
  web_search_require_sitemap?: boolean | null
  access_type?: string | null
}
